"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getConfig = exports.initialiseClientConfig = exports.initialiseServerConfig = exports.createConfig = void 0;

var _serializeJavascript = _interopRequireDefault(require("serialize-javascript"));

// safer serialise to help prevent XSS attacks
var config = {};
var environment = process.env.RAZZLE_DEPLOY_TARGET || "dev";
var isClient = typeof window !== "undefined";
/**
 * Creates a new configuration object.
 * @param {object} dev Development environment configuration.
 * @param {object} prod Producetion environment configuration.
 * @param {object} staging Producetion environment configuration.
 */

var createConfig = function createConfig(_ref) {
  var dev = _ref.dev,
      prod = _ref.prod,
      staging = _ref.staging;
  config = {
    dev: dev,
    prod: prod,
    staging: staging
  };
};
/**
 * Prepares the config for use server-side by adding
 * it to the node app's environment variables.
 *
 * This function saves the config in process.env.CONFIG.
 * It's saved as stringified JSON.
 */


exports.createConfig = createConfig;

var initialiseServerConfig = function initialiseServerConfig() {
  process.env.CONFIG = JSON.stringify(config[environment] || config.dev);
};
/**
 * Prepares the config for use client-side by creating a
 * script tag with the config injected. The config object
 * is added to window.env.
 *
 * This tag should be added to the HTML sent by the server.
 *
 * @example
 * createConfig({ dev: devConfig, prod: prodConfig })
 *
 * res.status(200).send(
 * `
 *  <head>
 *    ${initialiseClientConfig()}
 *  </head>
 * `
 * )
 */


exports.initialiseServerConfig = initialiseServerConfig;

var initialiseClientConfig = function initialiseClientConfig() {
  var configToUse = {
    CONFIG: config[environment] || config.dev
  };
  return "<script>window.env = " + (0, _serializeJavascript["default"])(configToUse) + "</script>";
};
/**
 * Returns the app's config.
 *
 * This function will return the config from either process.env or
 * window.env, depending on whether the app is running client-side
 * or server-side.
 */


exports.initialiseClientConfig = initialiseClientConfig;

var getConfig = function getConfig() {
  return isClient ? window.env.CONFIG : JSON.parse(process.env.CONFIG);
};

exports.getConfig = getConfig;